import { Injectable, inject } from '@angular/core';
import { isNil } from 'lodash-es';
import { first, filter } from 'rxjs/operators';
import { EnvironmentService } from './environment.service';
import { BehaviorSubject } from 'rxjs';


import { initializeApp } from 'firebase/app';
import { getAnalytics, logEvent } from 'firebase/analytics';

@Injectable({
  providedIn: 'root'
})
export class FirebaseAnalyticsService  {
  protected environmentService = inject(EnvironmentService);

  private analytics: any;
  private isInitializedSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  init() {
    /**
     * The core Firebase JS SDK is always required and must be listed first,
     * thus scripts are being synchronously.
     */

    let firebaseConfig;
    const environment = this.environmentService.resolve();

    switch(environment.envName) {
      /**
       * Supported environments
       */
      case 'acceptance':
      case 'staging':
      case 'prod': {
        firebaseConfig = environment.firebaseConfig;
      } break;

      default: {
        firebaseConfig = null;
      } break;
    }

    if (!isNil(firebaseConfig)) {
      try {
        const app = initializeApp(firebaseConfig);
        const analytics = getAnalytics(app);

        this.analytics = analytics;

      } catch(error) {
        console.error(error);
      }
    }

    this.isInitializedSubject.next(!isNil(this.analytics));
  }

  logEvent(eventName: string, args?: Record<string, unknown>) {
    this.isInitializedSubject
      .pipe(
        first(),
        filter(initialized => initialized),
      )
      .subscribe(() => {

        logEvent(this.analytics, eventName, args);
      });
  }
}
